<template>
  <div
    :style="{
      'background-color': useBackgroundColor,
      'padding-top': paddingTop + 'px',
      'padding-bottom': paddingBottom + 'px'
    }"
  >
    <div
      :class="{ 'container': useContainer, 'redirect-block-select': blockParams?.isUrl }"
      @click="$emit('block:redirect')"
    >
      <div class="page-showcase">
        <div class="page-showcase__content">
          <div v-if="mainFields.subtitle?.value" class="page-showcase__title">
            {{ mainFields.subtitle?.value }}
          </div>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div v-if="mainFields.text?.value" class="page-showcase__text" v-html="$options.filters.nl2br(mainFields.text?.value)" />
          <slot name="children" />
          <div
            v-if="(mainFields?.link?.value || mainFields?.form?.value) && mainFields?.linkTitle?.value || showAppStoresLinks"
            class="page-showcase__footer"
          >
            <nuxt-link
              v-if="mainFields?.link?.value && !mainFields?.link?.value?.startsWith(['https://'])"
              :to="mainFields?.link?.value"
              class="btn btn--full btn--white"
            >
              {{ mainFields?.linkTitle?.value }}
            </nuxt-link>
            <a
              v-else-if="mainFields?.link?.value"
              :href="mainFields?.link?.value"
              target="_blank"
              class="btn btn--full btn--white"
            >
              {{ mainFields?.linkTitle?.value }}
            </a>
            <div
              v-else-if="mainFields?.form?.value"
              class="btn btn--full btn--white"
              @click="openModal()"
            >
              {{ mainFields?.linkTitle?.value }}
            </div>
            <div v-if="showAppStoresLinks" class="app">
              <a href="https://apps.apple.com/ru/app/%D0%B5%D0%B2%D1%80%D0%BE%D0%B0%D0%BB%D1%8C%D1%8F%D0%BD%D1%81/id1591369936?platform=iphone" class="app-link app-link--color">
                <img
                  src="/img/app-store-color.svg"
                  alt=""
                  width="146"
                  height="46"
                  loading="lazy"
                >
              </a>
            </div>
          </div>
        </div>
        <div
          v-if="mainFields.icon?.value"
          class="page-showcase__image"
          :style="{
            'width': `${imageWidth}px`,
            'right': `${imageRight}px`
          }"
        >
          <img
            :src="$imageUrl(mainFields?.icon?.value, '', 'webp')"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default {
  mixins: [staticBlockMixin],
  inject: [
    'globalFormProvider',
    'setGlobalFormProviderProperties'
  ],
  props: {
    showAppStoresLinks: {
      type: Boolean,
      required: false,
      default: false
    },
    imageWidth: {
      type: [Number, String],
      required: false,
      default: 'unset'
    },
    imageRight: {
      type: [Number, String],
      required: false,
      default: 'unset'
    }
  },

  fetch () {
    if (+this.$route?.query?.form === this.mainFields?.form?.value) {
      this.setFormSettings()
    }
  },
  methods: {
    setFormSettings () {
      this.setGlobalFormProviderProperties({
        typeId: this.mainFields.form?.value,
        isLong: this.$attrs?.['is-long'] || this.blockParams?.isLong,
        formDefault: this.mainFields?.formDefault?.value
      })
    },
    openModal () {
      this.setFormSettings()
      this.$router.push({ query: { ...this.$route.query, form: this.mainFields?.form?.value } })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-showcase__content {
  max-width: 678px;
}

.page-showcase__image {
  position: relative;
}
</style>
